import { useEffect, useState } from "react";
import { whenFree } from "@/lib/popupQueue";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { DuelVersus } from "./DuelVersus";

const KEY = "itz_seen_duels";
const seen = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const busy = () => document.querySelector('[role="dialog"],[data-testid="lucky-wheel-modal"],[data-testid="level-up-modal"],[data-testid="scratch-big-celebration"],[data-testid="jackpot-celebration"],[data-testid="redeem-celebration"],[data-testid="new-games-intro"],[data-testid="duel-versus"]');

export function DuelCelebration() {
  const { user } = useAuth();
  const [ev, setEv] = useState(null);
  useEffect(() => {
    if (!user) return;
    const check = () => {
      if (document.visibilityState !== "visible" || busy()) return;
      api.get("/community/duel-latest").then(({ data }) => {
        if (!data || seen().includes(data.id)) return;
        whenFree(`duel-${data.id}`, () => {
          localStorage.setItem(KEY, JSON.stringify([...seen(), data.id].slice(-30)));
          setEv({ ...data, picked: data.my_cheer || null });
          setTimeout(() => setEv((c) => (c?.id === data.id && !c.picked ? null : c)), 12000);
        });
      }).catch(() => {});
    };
    const t = setTimeout(check, 8000);
    const iv = setInterval(check, 15000);
    return () => { clearTimeout(t); clearInterval(iv); };
  }, [user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!ev) return null;
  const [a, b] = ev.players;
  const onCheer = (pid) => {
    const before = { picked: ev.picked, cheers: ev.cheers };
    setEv((c) => ({ ...c, picked: pid, cheers: { ...c.cheers, [pid]: (c.cheers?.[pid] || 0) + 1 } }));
    api.post(`/duels/${ev.duel_id}/cheer`, { player_id: pid }).then(({ data }) => setEv((c) => c && { ...c, cheers: data.cheers }))
      .catch((er) => { setEv((c) => c && { ...c, ...before }); toast.error(er?.response?.data?.detail || "Anfeuern hat nicht geklappt"); });
  };
  return <DuelVersus testId="duel-celebration" players={ev.players} title="Live in der Community" onClose={() => setEv(null)}
    cheer={ev.duel_id ? { counts: ev.cheers, picked: ev.picked, onCheer } : undefined}
    text={`${a.name} und ${b.name} haben ein Punkte-Duell gestartet!${ev.stake ? ` Einsatz je ${ev.stake} Punkte ⚔️` : ""}`} />;
}
